import { render, staticRenderFns } from "./factoresRiesgoComponent.vue?vue&type=template&id=94a3ab1e"
import script from "./factoresRiesgoComponent.vue?vue&type=script&lang=js"
export * from "./factoresRiesgoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports